import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';
import UserFormModal from './UserFormModal';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API}/admin/users`);
      setUsers(response.data);
    } catch (error) {
      toast.error('Failed to fetch users');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (userId) => {
    if (!window.confirm('DELETE THIS USER AND ALL THEIR ENTRIES? [Y/N]')) return;

    try {
      await axios.delete(`${API}/admin/users/${userId}`);
      toast.success('User deleted');
      fetchUsers();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to delete user');
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setShowForm(true);
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    setEditingUser(null);
    fetchUsers();
  };

  if (loading) {
    return (
      <div className="retro-panel text-center py-12">
        <div className="text-2xl glow-text" style={{ color: '#FF6B00' }}>
          [LOADING USERS...]
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="retro-panel mb-6">
        <button
          onClick={() => {
            setEditingUser(null);
            setShowForm(true);
          }}
          data-testid="add-user-button"
          className="retro-btn"
        >
          [+ CREATE USER]
        </button>
      </div>

      <div className="retro-panel overflow-x-auto">
        <h2 className="text-3xl font-bold mb-6 glow-text" style={{ color: '#FF6B00', fontFamily: 'Orbitron, sans-serif' }}>
          [USERS] - TOTAL: {users.length}
        </h2>

        <div className="overflow-x-auto">
          <table className="retro-table" data-testid="users-table">
            <thead>
              <tr>
                <th>USERNAME</th>
                <th>EMAIL</th>
                <th>ROLE</th>
                <th>CREATED</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td style={{ color: '#ffffff', fontWeight: 700 }}>{user.username}</td>
                  <td style={{ color: 'rgba(255, 255, 255, 0.8)' }}>{user.email}</td>
                  <td style={{ color: user.is_admin ? '#FF6B00' : '#ffffff', fontWeight: 700 }}>
                    {user.is_admin ? 'ADMIN' : 'USER'}
                  </td>
                  <td>{new Date(user.created_at).toLocaleDateString()}</td>
                  <td>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEdit(user)}
                        data-testid={`edit-user-${user.id}`}
                        className="px-3 py-1 text-sm border-2 font-semibold"
                        style={{
                          color: '#ffffff',
                          borderColor: '#ffffff',
                          background: 'transparent',
                          boxShadow: '0 0 5px rgba(255, 255, 255, 0.3)'
                        }}
                      >
                        EDIT
                      </button>
                      <button
                        onClick={() => handleDelete(user.id)}
                        data-testid={`delete-user-${user.id}`}
                        className="px-3 py-1 text-sm border-2 font-semibold"
                        style={{
                          color: '#FF6B00',
                          borderColor: '#FF6B00',
                          background: 'transparent',
                          boxShadow: '0 0 5px rgba(255, 107, 0, 0.3)'
                        }}
                      >
                        DEL
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showForm && (
        <UserFormModal
          user={editingUser}
          onSuccess={handleFormSuccess}
          onCancel={() => {
            setShowForm(false);
            setEditingUser(null);
          }}
        />
      )}
    </>
  );
}